import React from 'react';
import PropTypes from 'prop-types';
import { CardContent, makeStyles } from '@material-ui/core';
import { useCostChartConfig } from '~/modules/common/charts/dashboard/config';
import { BarsChartLoading } from '~/modules/common/components/DetailsPage/Charts';
import BudgetCostChartLegends from '../BudgetCostChartLegends';
import { useProjectBudgetCostChartData } from '../hooks/useProjectBudgetCostChartData';
import { useBudgetCostSummary } from '../hooks/useBudgetCostSummary';
import BudgetChart from './BudgetChart';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap'
  }
}));

export const BudgetCostSummaryChart = ({
  projectDetails,
  projectBudgetCostTitleId
}) => {
  const classes = useStyles();

  const { actualBarColor, actualLabelColor } = useCostChartConfig();
  const { projectId } = projectDetails;

  const { projectCostSummary, isSummaryLoading } = useBudgetCostSummary({
    projectId
  });

  const {
    estimatedCostsDataPoints,
    actualCostsDataPoints
  } = useProjectBudgetCostChartData(projectCostSummary);

  return (
    <CardContent>
      {isSummaryLoading ? (
        <BarsChartLoading showLegends={false} />
      ) : (
        <div className={classes.content}>
          <BudgetChart
            titleId={projectBudgetCostTitleId}
            estimatedDataPoints={estimatedCostsDataPoints}
            actualDataPoints={actualCostsDataPoints}
            actualBarColor={actualBarColor}
            actualLabelColor={actualLabelColor}
            gradientId="gradientForBudgetCosts"
            maxBudgetLimit={projectCostSummary?.budgetedResourceCost?.amount}
          />
          <BudgetCostChartLegends
            actualBarColor={actualBarColor}
            projectCostSummary={projectCostSummary}
          />
        </div>
      )}
    </CardContent>
  );
};

BudgetCostSummaryChart.propTypes = {
  projectDetails: PropTypes.object,
  projectBudgetCostTitleId: PropTypes.string
};

export default BudgetCostSummaryChart;
